// extracted by mini-css-extract-plugin
export default {"ResetPasswordPage":"ResetPasswordPage_ResetPasswordPage__uGxKl","ResetPasswordPage__Description":"ResetPasswordPage_ResetPasswordPage__Description__5r5ZP"};